// extracted by mini-css-extract-plugin
export default {"container":"classes_container__Nph6l","bad":"classes_bad__HIeUl","correct":"classes_correct__3Gnb5"};